"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@/components/ui/resizable";
export default function Comparison() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const metrics = [{
    label: "REVENUE GROWTH",
    value: "45%",
    direction: "up"
  }, {
    label: "OTA COMMISSIONS",
    value: "22%",
    direction: "down"
  }, {
    label: "DIRECT BOOKINGS",
    value: "38%",
    direction: "up"
  }];
  return <section data-section-id="1261" id="channelmanagercomparison" className="bg-slate-50 text-slate-900 py-28 md:py-40 px-6 md:px-16 font-default overflow-hidden">
      <div ref={ref} className={`max-w-[1320px] mx-auto transition-all duration-[720ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
      transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
    }}>
        {}
        <div className="flex flex-col md:flex-row md:items-start gap-8 md:gap-12 mb-16 md:mb-24">
          {}
          <div className="flex md:flex-col items-center md:items-start gap-4 md:gap-3 md:pt-2 shrink-0">
            <span className="font-default text-2xl text-slate-700" style={{
            fontWeight: 300
          }}>
              01
            </span>
            <span className="font-sans text-[0.6875rem] md:text-[0.8125rem] uppercase text-slate-500" style={{
            letterSpacing: "0.22em"
          }}>
              02 — REVENUE TRANSFORMATION
            </span>
          </div>

          {}
          <div className="flex-1 md:pl-8 md:border-l md:border-slate-200">
            <h2 className="font-default text-slate-900" style={{
            fontSize: "clamp(2.125rem, 4.4vw, 4rem)",
            fontWeight: 700,
            letterSpacing: "-0.025em",
            lineHeight: 1.04
          }}>
              From fragmented{" "}
              <span className="font-serif italic font-light">
                operations
              </span>{" "}
              to unified{" "}
              <span className="font-serif italic font-light">
                profitability
              </span>
              .
            </h2>
          </div>
        </div>

        {}
        <div className="relative">
          {}
          <div className="hidden md:flex justify-between mb-6 px-1">
            <span className="font-sans text-[0.8125rem] uppercase text-slate-600" style={{
            letterSpacing: "0.22em"
          }}>
              BEFORE — MANUAL MANAGEMENT
            </span>
            <span className="font-sans text-[0.8125rem] uppercase text-slate-600" style={{
            letterSpacing: "0.22em"
          }}>
              AFTER — DATA-DRIVEN STRATEGY
            </span>
          </div>

          {}
          <div className="hidden md:block relative" style={{
          aspectRatio: "16 / 9"
        }}>
            {}
            <span className="absolute -top-2 -left-2 w-3 h-3 border-t border-l border-slate-300 z-20" />
            <span className="absolute -top-2 -right-2 w-3 h-3 border-t border-r border-slate-300 z-20" />
            <span className="absolute -bottom-2 -left-2 w-3 h-3 border-b border-l border-slate-300 z-20" />
            <span className="absolute -bottom-2 -right-2 w-3 h-3 border-b border-r border-slate-300 z-20" />

            <ResizablePanelGroup direction="horizontal" className="h-full w-full">
              <ResizablePanel defaultSize={50} minSize={10}>
                <div className="relative h-full w-full overflow-hidden">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/manual_revenue_chaos.png" alt="Disorganized hotel revenue spreadsheets and manual data entry" loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                  filter: "grayscale(0.9) sepia(0.15) contrast(0.95) brightness(0.85)"
                }} />
                  <div className="absolute inset-0 bg-slate-900/10 mix-blend-overlay pointer-events-none" />
                </div>
              </ResizablePanel>
              <ResizableHandle className="!w-px !bg-slate-300 relative after:absolute after:inset-y-0 after:left-1/2 after:w-8 after:-translate-x-1/2 after:bg-transparent">
                <div className="z-10 flex h-8 w-8 items-center justify-center rounded-lg border border-slate-300 bg-white">
                  <span className="block h-1.5 w-1.5 rounded-lg bg-amber-800" />
                </div>
              </ResizableHandle>
              <ResizablePanel defaultSize={50} minSize={10}>
                <div className="relative h-full w-full overflow-hidden">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/optimized_revenue_dashboard.png" alt="Modern hotel revenue management dashboard showing growth metrics" loading="lazy" decoding="async" className="h-full w-full object-cover" />
                </div>
              </ResizablePanel>
            </ResizablePanelGroup>
          </div>

          {}
          <div className="md:hidden flex flex-col gap-3">
            <div className="relative">
              <div className="flex items-center justify-between mb-2 px-1">
                <span className="font-sans text-[0.6875rem] uppercase text-slate-600" style={{
                letterSpacing: "0.22em"
              }}>
                  BEFORE — MANUAL MANAGEMENT
                </span>
              </div>
              <div className="relative overflow-hidden" style={{
              aspectRatio: "4 / 3"
            }}>
                <span className="absolute top-0 left-0 w-2 h-2 border-t border-l border-slate-300 z-20" />
                <span className="absolute top-0 right-0 w-2 h-2 border-t border-r border-slate-300 z-20" />
                <span className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-slate-300 z-20" />
                <span className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-slate-300 z-20" />
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/manual_revenue_chaos.png" alt="Disorganized hotel revenue spreadsheets and manual data entry" loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                filter: "grayscale(0.9) sepia(0.15) contrast(0.95) brightness(0.85)"
              }} />
              </div>
            </div>

            <div className="flex items-center justify-center gap-3 py-2">
              <span className="h-px flex-1 bg-slate-300" />
              <span className="block h-1.5 w-1.5 rounded-lg bg-amber-800" />
              <span className="h-px flex-1 bg-slate-300" />
            </div>

            <div className="relative">
              <div className="flex items-center justify-between mb-2 px-1">
                <span className="font-sans text-[0.6875rem] uppercase text-slate-600" style={{
                letterSpacing: "0.22em"
              }}>
                  AFTER — DATA-DRIVEN STRATEGY
                </span>
              </div>
              <div className="relative overflow-hidden" style={{
              aspectRatio: "4 / 3"
            }}>
                <span className="absolute top-0 left-0 w-2 h-2 border-t border-l border-slate-300 z-20" />
                <span className="absolute top-0 right-0 w-2 h-2 border-t border-r border-slate-300 z-20" />
                <span className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-slate-300 z-20" />
                <span className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-slate-300 z-20" />
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/optimized_revenue_dashboard.png" alt="Modern hotel revenue management dashboard showing growth metrics" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-20 pt-10 border-t border-slate-200">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-y-8 md:gap-y-0">
            {metrics.map((metric, i) => <div key={i} data-index={i} className={`flex flex-col items-center text-center md:px-6 ${i < metrics.length - 1 ? "md:border-r md:border-slate-200" : ""}`}>
                <span className="font-sans text-[0.75rem] uppercase text-slate-500 mb-3" style={{
              letterSpacing: "0.22em"
            }}>
                  {metric.label}
                </span>
                <div className="flex items-baseline gap-2">
                  <span className="font-sans text-xl md:text-2xl text-amber-800" style={{
                letterSpacing: "0.05em"
              }}>
                    {metric.direction === "down" ? "↓" : "↑"}
                  </span>
                  <span className="font-default text-2xl md:text-3xl text-slate-900" style={{
                fontWeight: 600,
                letterSpacing: "-0.02em"
              }}>
                    {metric.value}
                  </span>
                </div>
              </div>)}
          </div>

          {}
          <div className="mt-12 flex items-center gap-6">
            <span className="h-px flex-1 bg-slate-200" />
            <span className="font-sans text-[0.75rem] uppercase text-slate-400 whitespace-nowrap" style={{
            letterSpacing: "0.16em"
          }}>
              HOTELREVBABA CONSULTING
            </span>
            <span className="h-px flex-1 bg-slate-200" />
            <span className="block h-1.5 w-1.5 rounded-lg shrink-0 bg-amber-800" />
          </div>
        </div>
      </div>
    </section>;
}